<template>
  <section class="info-page">
    <h2>Contact us</h2>
    <div class="info-card">
      <p>Need help choosing a print, colour, size, or gift? We’d love to hear from you.</p>
      <a class="contact-email" href="mailto:Bumblefoxuk@gmail.com">Bumblefoxuk@gmail.com</a>
      <p class="contact-note">For library items, you can also use the quote request on the item or your favourites bundle.</p>
      <router-link to="/library" class="info-action">Explore the library</router-link>
    </div>
  </section>
</template>

<style scoped>
.info-page {
  min-height: 55vh;
  padding: 44px 20px;
  background: #fff8ef;
  text-align: center;
}

.info-card {
  max-width: 650px;
  margin: 24px auto 0;
  padding: 26px;
  border-radius: 16px;
  background: white;
  box-shadow: 0 6px 20px rgba(46, 45, 97, 0.1);
  line-height: 1.6;
}

.contact-email {
  color: #2e2d61;
  font-size: 1.15rem;
  font-weight: 800;
}

.contact-note {
  margin-top: 22px;
}

.info-action {
  display: inline-block;
  margin-top: 8px;
  padding: 11px 20px;
  border-radius: 999px;
  background: #2e2d61;
  color: white;
  font-weight: 700;
  text-decoration: none;
}
</style>
